import { Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "./auth.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class InactivityService {
  private inactivityTimer: any;
  private readonly INACTIVITY_TIMEOUT = environment.inactivityTimeout;

  // Eventos que indicam atividade do usuário
  private readonly ACTIVITY_EVENTS = [
    "mousemove",
    "mousedown",
    "keypress",
    "scroll",
    "touchstart",
  ];

  private boundResetTimer: () => void;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private ngZone: NgZone,
  ) {
    // Bind do método resetTimer para uso nos event listeners
    this.boundResetTimer = this.resetTimer.bind(this);
  }

  /**
   * Inicia o monitoramento de inatividade
   */
  public startMonitoring(): void {
    // Adiciona listeners para eventos de atividade
    this.ACTIVITY_EVENTS.forEach((event) => {
      window.addEventListener(event, this.boundResetTimer, true);
    });

    // Inicia o timer de inatividade
    this.resetTimer();
  }

  /**
   * Para o monitoramento e limpa recursos
   */
  public stopMonitoring(): void {
    // Remove todos os event listeners
    this.ACTIVITY_EVENTS.forEach((event) => {
      window.removeEventListener(event, this.boundResetTimer, true);
    });

    // Limpa o timer
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = null;
    }
  }

  /**
   * Reseta o timer de inatividade
   */
  private resetTimer(): void {
    // Limpa o timer anterior se existir
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
    }

    // Cria novo timer fora da zona do Angular para melhor performance
    this.ngZone.runOutsideAngular(() => {
      this.inactivityTimer = setTimeout(() => {
        // Executa logout dentro da zona do Angular
        this.ngZone.run(() => {
          this.handleInactivityTimeout();
        });
      }, this.INACTIVITY_TIMEOUT);
    });
  }

  /**
   * Executa logout quando o tempo de inatividade expira
   */
  private handleInactivityTimeout(): void {
    // Para o monitoramento
    this.stopMonitoring();

    // Executa logout através do AuthenticationService
    this.authService.logout().subscribe({
      next: () => {
        // Redireciona para login
        this.router.navigate(["/account/login"], {
          queryParams: { reason: "inactivity" },
        });
      },
      error: () => {
        // Mesmo em caso de erro, redireciona para login
        this.router.navigate(["/account/login"], {
          queryParams: { reason: "inactivity" },
        });
      },
    });
  }
}
